import { jsx as e, jsxs as b } from "react/jsx-runtime";
import { useId as f, useState as x, useRef as u } from "react";
import w from "./useOutsideClick.js";
import { tv as m } from "tailwind-variants";
import h from "./Icon.js";
import v from "next/link.js";
const k = m({
  slots: {
    wrapper: ["border-neutral-200", "border-t", "first:border-0"],
    base: [
      "block",
      "cursor-pointer",
      "font-bold",
      "font-secondary",
      "italic",
      "py-2",
      "text-left",
      "text-neutral-500",
      "text-sm",
      "tracking-wider",
      "uppercase",
      "whitespace-nowrap",
      "w-full"
    ]
  }
}), { wrapper: I, base: N } = k(), y = ({ className: o, children: a, href: t, onClick: s }) => {
  const l = t ? v : "button";
  return /* @__PURE__ */ e("li", { className: I(), children: /* @__PURE__ */ e(
    l,
    {
      className: N({ class: o }),
      href: t,
      onClick: s,
      children: a
    }
  ) });
}, g = {
  kebab: "ellipsis-vertical",
  meatballs: "ellipsis"
}, $ = m({
  slots: {
    wrapper: ["relative"],
    button: ["cursor-pointer", "text-neutral-900", "text-2xl"],
    list: [
      "absolute",
      "bg-white",
      "border",
      "border-neutral-200",
      "hidden",
      "px-4",
      "right-0",
      "rounded-lg",
      "shadow-md",
      "top-[2.1rem]",
      "z-10"
    ]
  },
  variants: {
    hasBackground: {
      true: {
        button: [
          "aspect-square",
          "bg-white",
          "flex",
          "items-center",
          "justify-center",
          "rounded-full",
          "w-[2.6rem]"
        ],
        list: ["top-[3.3rem]"]
      }
    },
    isActive: {
      true: {
        list: ["block"]
      }
    }
  }
}), { wrapper: C, button: S, list: j } = $(), A = ({
  buttonClassName: o,
  className: a,
  children: t,
  hasBackground: s,
  icon: l = "meatballs",
  name: d
}) => {
  const i = `options-${f()}`, [r, n] = x(), c = u(), p = u();
  return w(c, p, () => n(!1)), /* @__PURE__ */ b("div", { className: C({ class: a }), children: [
    /* @__PURE__ */ e(
      "button",
      {
        "aria-controls": i,
        "aria-expanded": r,
        "aria-haspopup": "menu",
        "aria-label": `${r ? "Close" : "Open"} ${d} menu`,
        className: S({ class: o, hasBackground: s }),
        onClick: () => n(!r),
        ref: c,
        children: /* @__PURE__ */ e(h, { name: g[l], style: "solid" })
      }
    ),
    /* @__PURE__ */ e(
      "ul",
      {
        className: j({ hasBackground: s, isActive: r }),
        ref: p,
        id: i,
        children: t
      }
    )
  ] });
};
A.Item = y;
export {
  A as default
};
